import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {useParams} from 'react-router-dom';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {Lien} from '@app/titles/models/lien';
import {Nzb} from '@app/titles/models/nzb';
import {Torrent} from '@app/titles/models/torrent';

export interface GetLinkResponse extends BackendResponse {
  model: Lien | Nzb | Torrent;
}

export function useLien(loader: 'link' | 'adminLink') {
  const {lienId, nzbId, torrentId} = useParams();
  const id = lienId ?? nzbId ?? torrentId;
  const endpoint = lienId ? 'liens' : nzbId ? 'nzb' : 'torrents';
  return useQuery({
    queryKey: [endpoint, `${id}`],
    queryFn: () => fetchLien(id!, endpoint, loader),
    initialData: () => {
      const data = getBootstrapData().loaders?.[loader];
      if (data?.model?.id == id) {
        return data;
      }
      return undefined;
    },
  });
}

function fetchLien(id: number | string, endpoint: string, loader: string) {
  return apiClient
    .get<GetLinkResponse>(`${endpoint}/${id}`)
    .then(response => response.data);
}
